import React, { useState } from 'react';
import { getVerification, getImages } from './services/verificationService';
import './SearchTransaction.css';

function SearchTransaction({ onBack, onSearchResults }) {
  const [searchId, setSearchId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searched, setSearched] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    
    if (!searchId.trim()) {
      setError('Please enter a transaction ID');
      return;
    }

    setLoading(true);
    setError(null);
    setSearched(true);

    try {
      const results = await getVerification(searchId);

      // Also fetch stored images from DB
      try {
        const images = await getImages(results.verificationId);
        if (images && images.length > 0) {
          images.forEach(img => {
            if (img.type === 'selfie') results.referenceImage = img.data;
            if (img.type === 'front') results.frontImage = img.data;
            if (img.type === 'back') results.backImage = img.data;
          });
        }
      } catch (imgErr) {
        console.warn('Could not fetch images:', imgErr);
      }

      if (onSearchResults) {
        onSearchResults(results);
      }
    } catch (err) {
      console.error('Error retrieving verification:', err);
      setError('Transaction ID not found. Please check and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="search-transaction-container">
      <div className="search-form-section">
        <button className="back-button" onClick={onBack}>
          ← Back
        </button>

        <div className="search-card">
          <h2>Search Verification Record</h2>
          <p className="search-description">
            Enter your transaction ID to retrieve your verification results
          </p>

          <form onSubmit={handleSearch} className="search-form">
            <div className="form-group">
              <label htmlFor="transactionId">Transaction ID</label>
              <input
                id="transactionId"
                type="text"
                value={searchId}
                onChange={(e) => setSearchId(e.target.value)}
                placeholder="e.g., 550e8400-e29b-41d4-a716-446655440000"
                className="search-input"
                disabled={loading}
              />
            </div>

            {error && (
              <div className="error-message">
                ⚠️ {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading || !searchId.trim()}
              className="search-button"
            >
              {loading ? (
                <>
                  <span className="spinner-small"></span> Searching...
                </>
              ) : (
                '🔍 Search'
              )}
            </button>
          </form>

          {searched && !loading && error && (
            <div className="no-results">
              <p>No verification record found for this ID.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchTransaction;
